(() => {
  'use strict';
  const read = node => { try { return JSON.parse(node?.textContent || '[]'); } catch { return []; } };
  const init = (root = document) => {
    root.querySelectorAll('.dn-native-form,.dn-bed-native-form').forEach(form => {
      if (form.dataset.checkoutReady) return;
      form.dataset.checkoutReady = 'true';
      const scope = form.closest('[data-dn-pdp]');
      if (!scope) return;
      const variants = read(scope.querySelector('[data-dn-variant-data]'));
      const colour = scope.querySelector('[data-dn-blanket-colour]');
      const addon = scope.querySelector('[data-dn-blanket-addon]');
      const addonCheck = addon?.querySelector('[data-dn-bundle-check]');
      const addonColour = addon?.querySelector('[data-dn-bundle-colour]');
      const addonVariants = read(addon?.querySelector('[data-dn-addon-variants]'));
      const id = form.querySelector('[name="id"]');
      const quantityInput = form.querySelector('[name="quantity"]');
      // Shopify's additional-item fields are consumed by the native wallet buttons.
      // Keep them separate from the Ajax payload used by our ordinary buy buttons.
      const walletFields = {};
      if (addon) {
        for (const attribute of ['id','quantity']) {
          const field = document.createElement('input');
          field.type = 'hidden';
          field.name = `shopify-additional-items[1][${attribute}]`;
          field.disabled = true;
          form.append(field);
          walletFields[attribute] = field;
        }
      }
      const error = form.querySelector('[data-dn-checkout-error]');
      let pending = false;
      const showError = message => { error.textContent = message; error.hidden = false; error.scrollIntoView({block:'nearest'}); };
      const availability = () => {
        if (!id?.value || id.disabled) return false;
        if (variants.length) return variants.some(v => String(v.id) === id.value && v.available);
        return Boolean(form.querySelector('[data-dn-live-size]:checked:not(:disabled)'));
      };
      const sync = () => {
        if (colour) {
          const option = colour.selectedOptions[0];
          const selectedId = option?.dataset.variantId || '';
          if (id.value !== selectedId) {
            id.value = selectedId;
            id.dispatchEvent(new Event('change',{bubbles:true}));
          }
          const variant = variants.find(v => String(v.id) === id.value);
          if (variant) scope.querySelector('[data-dn-price]').textContent = new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(variant.price / 100);
        }
        const available = availability();
        scope.querySelectorAll('[data-dn-sticky-checkout]').forEach(button => { button.disabled = pending || (!available && !form.classList.contains('dn-bed-native-form')); });
        form.querySelectorAll('[data-dn-native-submit],[data-dn-native-buy-now],[data-dn-live-buy]').forEach(button => {
          button.disabled = pending || !available;
          if (button.hasAttribute('data-dn-native-submit')) button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
        });
        const quantity = Number(quantityInput.value);
        const validQuantity = Number.isInteger(quantity) && quantity >= 1 && quantity <= 99;
        const addonOption = addonColour?.selectedOptions[0];
        const addonAvailable = !addonCheck?.checked || (addonOption && !addonOption.disabled && addonVariants.some(v => String(v.id) === addonOption.dataset.variantId && v.available));
        if (addon) {
          const included = Boolean(addonCheck?.checked && addonAvailable && validQuantity);
          walletFields.id.value = included ? addonOption.dataset.variantId : '';
          walletFields.quantity.value = included ? String(quantity) : '';
          walletFields.id.disabled = walletFields.quantity.disabled = !included;
        }
        form.querySelectorAll('[data-dn-native-wallets],[data-dn-live-wallets]').forEach(wallet => { wallet.hidden = pending || !available || !validQuantity || !addonAvailable; });
        if (form.classList.contains('dn-bed-native-form')) {
          const sticky = scope.querySelector('[data-dn-sticky-buy]');
          const stickyPrice = scope.querySelector('[data-dn-sticky-price]');
          const selectedSize = form.querySelector('[data-dn-live-size]:checked');
          if (sticky) sticky.textContent = available ? sticky.dataset.addLabel : sticky.dataset.chooseLabel;
          if (stickyPrice && !addon) {
            stickyPrice.dataset.startingPrice ||= stickyPrice.textContent;
            stickyPrice.textContent = selectedSize ? selectedSize.dataset.price : stickyPrice.dataset.startingPrice;
          }
          if (selectedSize) {
            const selectedPrice = scope.querySelector('[data-dn-price]');
            if (selectedPrice) selectedPrice.textContent = selectedSize.dataset.price;
          }
        }
        if (scope.hasAttribute('data-dn-blanket')) {
          const stickyPrice = scope.querySelector('[data-dn-sticky-price]');
          const selectedVariant = variants.find(variant => String(variant.id) === id.value);
          if (stickyPrice && selectedVariant) stickyPrice.textContent = new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(selectedVariant.price * (validQuantity ? quantity : 1) / 100);
          const stickyButton = scope.querySelector('[data-dn-sticky-buy]');
          if (stickyButton) {
            stickyButton.disabled = pending || !available || !validQuantity;
            stickyButton.textContent = available ? stickyButton.dataset.addLabel : stickyButton.dataset.chooseLabel;
          }
        }
      };
      if (colour) {
        [...colour.options].forEach(option => {
          const variant = variants.find(v => String(v.id) === option.dataset.variantId);
          option.disabled = !variant?.available;
          scope.querySelector(`[data-dn-blanket-swatch="${option.value}"]`)?.setAttribute('aria-disabled', String(option.disabled));
        });
        const params = new URL(location.href).searchParams;
        const requested = [...colour.options].find(option => option.dataset.variantId === params.get('variant'));
        if (requested && !params.has('colour')) { colour.value = requested.value; colour.dispatchEvent(new Event('change',{bubbles:true})); }
        else if (!params.has('colour') && colour.selectedOptions[0]?.disabled) {
          const first = [...colour.options].find(option => !option.disabled);
          if (first) { colour.value=first.value; colour.dispatchEvent(new Event('change',{bubbles:true})); }
        }
        // Swatches and gallery colour choices update the same native purchase variant.
        scope.addEventListener('click', () => queueMicrotask(sync));
      }
      if (addonColour) {
        [...addonColour.options].forEach(option => {
          option.disabled = !addonVariants.some(v => String(v.id) === option.dataset.variantId && v.available);
        });
        if (addonColour.selectedOptions[0]?.disabled) {
          const first = [...addonColour.options].find(option => !option.disabled);
          if (first) addonColour.value = first.value;
        }
        addonColour.dispatchEvent(new Event('change',{bubbles:true}));
      }
      scope.addEventListener('change', () => queueMicrotask(sync));
      scope.addEventListener('input', sync);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (pending) return;
        error.hidden = true;
        sync();
        if (!form.reportValidity() || !availability()) return;
        const quantity = Number(form.querySelector('[name="quantity"]').value);
        if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99) { showError('Please choose a quantity from 1 to 99.'); return; }
        const items = [{id:id.value,quantity}];
        if (addonCheck?.checked) {
          const option = addonColour.selectedOptions[0];
          if (!option || option.disabled || !option.dataset.variantId) { showError('Please choose an available blanket colour.'); return; }
          items.push({id:option.dataset.variantId,quantity});
        }
        const buyNow = event.submitter?.hasAttribute('data-dn-native-buy-now') || event.submitter?.hasAttribute('data-dn-live-buy');
        const checkoutWindow = buyNow && window.Shopify?.designMode ? window.open('about:blank','_blank') : null;
        pending = true; form.setAttribute('aria-busy','true'); sync();
        try {
          const route = new URL(form.action,location.origin);
          route.pathname = route.pathname.replace(/\/cart\/add\/?$/, '/cart/add.js');
          const response = await fetch(route.pathname,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok || result.status >= 400) throw new Error(result.description || 'This item could not be added.');
          const base = window.Shopify?.routes?.root || '/';
          if (checkoutWindow) { checkoutWindow.location.href = base + 'checkout'; pending=false; form.removeAttribute('aria-busy'); sync(); }
          else location.assign(base + (buyNow ? 'checkout' : 'cart'));
        } catch (cause) {
          checkoutWindow?.close();
          showError((cause.message || 'We could not confirm your basket update.') + ' Please check your basket before trying again.');
          const link = document.createElement('a'); link.href=(window.Shopify?.routes?.root || '/')+'cart'; link.textContent=' View basket'; error.append(link);
          pending = false; form.removeAttribute('aria-busy'); sync();
        }
      });
      const requestedVariant = new URL(location.href).searchParams.get('variant');
      const requestedSize = [...form.querySelectorAll('[data-dn-live-size]')].find(input => input.value === requestedVariant && !input.disabled);
      if (requestedSize) { requestedSize.checked = true; requestedSize.dispatchEvent(new Event('change', {bubbles:true})); }
      sync();
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();